
export enum ClaimPaymentMethodCd {
	CHECK = 'Check',
	ELECTRONIC_FUNDS_TRANSFER = 'ElectronicFundsTransfer'}

